import { Component } from 'react'
import { Box, Icons, KeyValueRow } from 'stylewhere/components'
import { T, __ } from 'stylewhere/shared/i18n'
import { EncodingCounters } from 'stylewhere/api'
import {
  getEncodedOrder,
  getEncodedOrderRow,
  getEncodedParent,
  getExpectedOrder,
  getExpectedParent,
  getExpectedRow
} from 'stylewhere/utils'

export interface EncodingCountersBoxProps {
  counters?: EncodingCounters
  productionOrderDetail?: () => void
}

export class EncodingCountersBox extends Component<EncodingCountersBoxProps> {
  render() {
    const { counters, productionOrderDetail } = this.props
    return (
      <KeyValueRow style={{ margin: 2 }}>
        <KeyValueRow
          variant="raw"
          value={`${getEncodedParent(counters)} / ${getExpectedParent(counters)}`}
          label={__(T.misc.item_po)}
        />
        <Box height={60} width={2} bgGrey />
        <KeyValueRow
          variant="raw"
          value={`${getEncodedOrder(counters)} / ${getExpectedOrder(counters)}`}
          label={__(T.misc.item_order)}
          onClick={productionOrderDetail}
          image={productionOrderDetail ? <Icons.Info width={22} height={22} /> : undefined}
        />
        {counters.row && (
          <>
            <Box height={60} width={2} bgGrey />
            <KeyValueRow
              variant="raw"
              value={`${getEncodedOrderRow(counters)} / ${getExpectedRow(counters)}`}
              label={__(T.misc.item_row)}
            />
          </>
        )}
      </KeyValueRow>
    )
  }
}
